import DeleteBrandModal from './DeleteBrandModal';

export default DeleteBrandModal;
